export default "__VITE_ASSET__BuwO$EBD__"